import Footer from '../../component/Footer';

import React from 'react';

export const FooterPage = () => {
  return <Footer />;
};
